import Cookie from 'js-cookie';
import { getCookieDomain } from './helpers';
export var WFE_TOKEN_KEY = 'wfeToken';
export var getJwt = function getJwt() {
  return localStorage.getItem(WFE_TOKEN_KEY);
};
export var setJwt = function setJwt(jwt) {
  return localStorage.setItem(WFE_TOKEN_KEY, jwt);
};
export var clearJwt = function clearJwt() {
  return localStorage.removeItem(WFE_TOKEN_KEY);
};
export var clearLegacyCookie = function clearLegacyCookie(site) {
  return Cookie.remove(WFE_TOKEN_KEY, {
    path: '/',
    domain: getCookieDomain(site)
  });
};